module.exports = __webpack_public_path__ + "static/media/winter.8e161b56.png";